var map = {
	"./": [
		78
	],
	"./components/TriviaExitPopup": [
		283,
		9
	],
	"./components/TriviaExitPopup.tsx": [
		283,
		9
	],
	"./icons/CloseIcon": [
		147
	],
	"./icons/CloseIcon.tsx": [
		147
	],
	"./icons/FullIcon": [
		280,
		10
	],
	"./icons/FullIcon.tsx": [
		280,
		10
	],
	"./icons/MenuIcon": [
		284,
		11
	],
	"./icons/MenuIcon.tsx": [
		284,
		11
	],
	"./icons/XIcon": [
		285,
		12
	],
	"./icons/XIcon.tsx": [
		285,
		12
	],
	"./index": [
		78
	],
	"./index.tsx": [
		78
	],
	"./text.style": [
		281,
		13
	],
	"./text.style.ts": [
		281,
		13
	],
	"./types": [
		130
	],
	"./types.ts": [
		130
	],
	"./v1": [
		163,
		3
	],
	"./v1/": [
		163,
		3
	],
	"./v1/index": [
		163,
		3
	],
	"./v1/index.tsx": [
		163,
		3
	],
	"./v2": [
		167,
		2
	],
	"./v2/": [
		167,
		2
	],
	"./v2/index": [
		167,
		2
	],
	"./v2/index.tsx": [
		167,
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 430;
module.exports = webpackAsyncContext;